export function setupSuggestionsUI(app, search, isFirstApp = false) {
    if (!app.classList.contains('type-suggestions')) return;

    const searchBoxContainer = app.querySelector('.snaf-searchbox');
    const dropdown = app.querySelector('.snaf-suggestions-dropdown');
    const closeBtn = app.querySelector('.snaf-suggestions-close');
    const filterBtn = app.querySelector('.snaf-mobile-filter-toggle');

    if (!searchBoxContainer || !dropdown) return;

    let isInjected = false;
    let originalWrapper = null;
    let hiddenContentWrapper = null;
    let injectedAppContainer = null;
    let originalDropdownParent = dropdown.parentElement;
    let originalDropdownNextSibling = dropdown.nextSibling;
    let preSearchUrl = null;

    const getWrapperSelector = () => {
        const config = window.snapFindPublic?.frontend?.suggestions_wrapper;
        return config && config.trim() !== '' ? config : 'main#brx-content';
    };

    const injectIntoWrapper = () => {
        if (isInjected) return;
        const selector = getWrapperSelector();
        originalWrapper = document.querySelector(selector);

        if (!originalWrapper) {
            console.warn(
                `[SnapFind] Wrapper selector "${selector}" not found. Falling back to body.`
            );
            originalWrapper = document.body;
        }

        // Save URL, ensuring we strip suggestions state so closing reverts cleanly
        const url = new URL(window.location.href);
        const keysToDelete = [];
        url.searchParams.forEach((val, key) => {
            if (key === 'sq' || key.startsWith('s_')) {
                keysToDelete.push(key);
            }
        });
        keysToDelete.forEach((key) => url.searchParams.delete(key));
        preSearchUrl = url.toString();

        // Hide original content
        hiddenContentWrapper = document.createElement('div');
        hiddenContentWrapper.style.display = 'none';
        hiddenContentWrapper.className = 'snaf-hidden-original-content';

        while (originalWrapper.firstChild) {
            hiddenContentWrapper.appendChild(originalWrapper.firstChild);
        }
        originalWrapper.appendChild(hiddenContentWrapper);

        // Inject dropdown wrapped in snapfind-app to preserve CSS
        injectedAppContainer = document.createElement('div');
        injectedAppContainer.className =
            'snapfind-app standalone type-suggestions snaf-injected-app';
        injectedAppContainer.id = 'snapfind-app';

        dropdown.classList.add('is-injected-mode');
        injectedAppContainer.appendChild(dropdown);
        originalWrapper.appendChild(injectedAppContainer);

        isInjected = true;
        app.classList.add('snaf-suggestions-open');
    };

    const removeInjection = () => {
        if (!isInjected) return;

        // Move dropdown back
        dropdown.classList.remove('is-injected-mode');
        if (originalDropdownParent && dropdown.parentElement !== originalDropdownParent) {
            originalDropdownParent.insertBefore(dropdown, originalDropdownNextSibling);
        }

        if (injectedAppContainer && injectedAppContainer.parentNode) {
            injectedAppContainer.parentNode.removeChild(injectedAppContainer);
            injectedAppContainer = null;
        }

        // Restore wrapper content
        if (originalWrapper && hiddenContentWrapper) {
            while (hiddenContentWrapper.firstChild) {
                originalWrapper.insertBefore(hiddenContentWrapper.firstChild, hiddenContentWrapper);
            }
            if (hiddenContentWrapper.parentNode === originalWrapper) {
                originalWrapper.removeChild(hiddenContentWrapper);
            }
        }

        isInjected = false;
        app.classList.remove('snaf-suggestions-open');

        // Clear search state (facets, query)
        if (search) {
            search.setUiState({});
        }

        // Clear input natively
        const inputs = app.querySelectorAll('.ais-SearchBox-input');
        inputs.forEach((input) => {
            if (input.value !== '') {
                input.value = '';
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        });

        // Restore URL
        if (preSearchUrl) {
            window.history.pushState(null, '', preSearchUrl);
            preSearchUrl = null;
        }
    };

    // Show dropdown on type
    searchBoxContainer.addEventListener('input', (e) => {
        if (e.target.classList.contains('ais-SearchBox-input')) {
            const val = e.target.value.trim();

            if (val.length > 0) {
                if (!isInjected) {
                    injectIntoWrapper();
                }
            } else {
                // If user clears the input completely, close the suggestions
                removeInjection();
            }
        }
    });

    // Handle Enter key
    searchBoxContainer.addEventListener('keydown', (e) => {
        if (e.target.classList.contains('ais-SearchBox-input')) {
            if (e.key === 'Enter') {
                e.preventDefault();
                e.target.blur(); // Dismiss mobile keyboard
            }
        }
    });

    // Auto-inject on load if there's a dedicated suggestions query in the URL
    if (isFirstApp) {
        const urlParams = new URLSearchParams(window.location.search);
        const suggestionsQuery = urlParams.get('sq') || '';

        // If 'sq' is present, the modal was active in history, so we must restore it
        if (suggestionsQuery.trim().length > 0) {
            // Need a slight delay to ensure InstantSearch has fully rendered the initial hits
            setTimeout(() => {
                if (!isInjected) {
                    injectIntoWrapper();
                }
            }, 50);
        }
    }

    // Close handlers
    if (closeBtn) {
        closeBtn.addEventListener('click', removeInjection);
    }

    // Close on Escape from anywhere
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isInjected) {
            removeInjection();
            const input = searchBoxContainer.querySelector('.ais-SearchBox-input');
            if (input && document.activeElement === input) {
                input.blur();
            }
        }
    });
}
